/**
 * Salva lo stato di un'azione sul CRM di un suggerimento (confermata o
 * scartata) nella colonna whatsapp_agent_requests.crm_actions e aggiorna la
 * lista dei suggerimenti nello store. Un suggerimento "solo CRM" senza piu'
 * azioni da decidere viene chiuso (status dismissed, con chi l'ha gestito).
 */
import { supabase } from '@/lib/supabase';
import { useWhatsAppAgentStore } from '@/lib/stores/whatsappAgentStore';
import type { AgentRequest } from '@/lib/types/whatsappAgent';
import { setActionStatus, shouldCloseSuggestion, type CrmActionStatus } from './suggestionCrmActionsLogic';

export async function saveCrmActionStatus(
  request: AgentRequest,
  actionId: string,
  status: CrmActionStatus,
  userId: string | null,
): Promise<boolean> {
  const actions = setActionStatus(request.crm_actions, actionId, status);
  const close = shouldCloseSuggestion(request.request_type, actions);
  const now = new Date().toISOString();
  const update: Record<string, unknown> = { crm_actions: actions, updated_at: now };
  if (close) {
    update.status = 'dismissed';
    if (userId) { update.reviewed_by = userId; update.reviewed_at = now; }
  }

  const { error } = await supabase
    .from('whatsapp_agent_requests')
    .update(update)
    .eq('id', request.id)
    .eq('organization_id', request.organization_id);
  if (error) {
    console.error('[suggestionCrmActions] stato azione non salvato:', error);
    return false;
  }

  useWhatsAppAgentStore.setState((st) => ({
    chatSuggestions: close
      ? st.chatSuggestions.filter((s) => s.id !== request.id)
      : st.chatSuggestions.map((s) => (s.id === request.id ? { ...s, crm_actions: actions } : s)),
  }));
  return true;
}
